export default {
	api: 'https://chauffeur.ust.hk/trns/api',
	// google_api_key: 'AIzaSyDiARCkpWhgMMPSmb2zx2jWySD31wxUIgc', // To Be Updated
	google_api_key: 'AIzaSyBFpO3OKLQK-qjP0QKoBck6n5JkcZQPcw8', // beautitag-production
	loginTimeout: 18000000
};
